import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useState, useEffect } from "react";
import { translate } from "../localization/translateService";
import { REGEX } from "../constants/regex";

export default function GuestEmailVerificationModal({ isOpen, onVerified, onClose }) {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [translations, setTranslations] = useState({
    title: "",
    emailLabel: "",
    emailPlaceholder: "",
    registerButton: "",
    invalidEmail: "",
  });

  useEffect(() => {
    const load = async () => {
      const [title, emailLabel, emailPlaceholder, registerButton, invalidEmail] =
        await Promise.all([
          translate("UMBRACO_LANDING.FREE_TEST.OTP.TITLE"),
          translate("UMBRACO_LANDING.FREE_TEST.OTP.EMAIL_LABEL"),
          translate("UMBRACO_LANDING.FREE_TEST.OTP.EMAIL_PLACEHOLDER"),
          translate("UMBRACO_LANDING.FREE_TEST.OTP.REGISTER_BUTTON"),
          translate("UMBRACO_LANDING.FREE_TEST.OTP.INVALID_EMAIL"),
        ]);
      setTranslations({ title, emailLabel, emailPlaceholder, registerButton, invalidEmail });
    };
    load();
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setEmail("");
      setEmailError("");
    }
  }, [isOpen]);

  const handleSubmit = () => {
    const trimmed = email.trim().toLowerCase();
    if (!REGEX.EMAIL.test(trimmed)) {
      setEmailError(translations.invalidEmail || "Invalid Email");
      return;
    }
    setIsSubmitting(true);
    onVerified(trimmed);
    setIsSubmitting(false);
  };

  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      className="keduall-dialog guest-email-otp-modal"
      header={translations.title || "Email Verification"}
      draggable={false}
      autoFocus={false}
      blockScroll={true}
      contentClassName="keduall-scrollbar"
      baseZIndex="10001"
    >
      <div className="flex flex-column gap-3">
        <div className="flex flex-column gap-1">
          <label className="keduall-typography text-14-medium-500">{translations.emailLabel || "Email"}</label>
          <input
            className="keduall-input w-full"
            type="email"
            value={email}
            placeholder={translations.emailPlaceholder || "Enter your email"}
            onChange={(e) => {
              setEmail(e.target.value);
              if (emailError) setEmailError("");
            }}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
          />
          {emailError && <p className="keduall-typography text-14-normal-400" style={{ color: "#F00" }}>{emailError}</p>}
        </div>
        <Button
          className="keduall-buttons button-filled-default-normal-primary w-full"
          onClick={handleSubmit}
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          <p className="keduall-typography text-16-semibold-600">{translations.registerButton || "Register"}</p>
        </Button>
      </div>
    </Dialog>
  );
}
